import Ajax from '@utils/ajax';

export default {
  fetch(group, options = {}) {
    return Ajax.get({
      url: `/groups/${group.id}/request_access`,
      ...options,
    });
  },

  getForUser(group, options = {}) {
    return Ajax.get({
      url: `/groups/${group.id}/request_access/requested_by_user`,
      data: {},
      ...options,
    });
  },

  create(group, data, options = {}) {
    return Ajax.post({
      url: `/groups/${group.id}/request_access`,
      data: { request_access: data },
      ...options,
    });
  },

  accept(groupId, requestAccess, options = {}) {
    return Ajax.post({
      url: `/groups/${groupId}/request_access/${requestAccess.id}`,
      data: {
        accept: true,
        _method: 'PATCH',
      },
      ...options,
    });
  },

  decline(groupId, requestAccess, options = {}) {
    return Ajax.post({
      url: `/groups/${groupId}/request_access/${requestAccess.id}`,
      data: {
        accept: false,
        _method: 'PATCH',
      },
      ...options,
    });
  },
};
